import { makeStyles } from "@saleor/macaw-ui";
import { formatThousandDecimal } from "@saleor/utils/number";
import React, { useMemo } from "react";

interface DecimalFormatProps {
  value: number;
  isGrayDecimal?: boolean;
  countDecimal?: number;
}

const useStyles = makeStyles(
  theme => ({
    decimal: {
      color: theme.palette.grey[500]
    },
    number: {
      color: theme.palette.grey[900]
    }
  }),
  { name: "DecimalFormat" }
);
const DecimalFormat: React.FC<DecimalFormatProps> = ({
  value,
  countDecimal,
  isGrayDecimal
}) => {
  const classes = useStyles();
  const number = useMemo(() => formatThousandDecimal(value, countDecimal), [
    value,
    countDecimal
  ]);
  const isValueEqualZero =
    value === 0 ? (
      <span className={classes.number}>0.00</span>
    ) : (
      <span className={classes.number}>0.{"0".repeat(countDecimal)}</span>
    );

  const numberSplit = number.split(".");
  return value && !isGrayDecimal ? (
    <span className={classes.number}>{number}</span>
  ) : value && isGrayDecimal ? (
    <>
      <span className={classes.number}>{numberSplit[0]}</span>
      <span className={classes.decimal}>{`.${numberSplit[1]}`}</span>
    </>
  ) : (
    isValueEqualZero
  );
};

export default DecimalFormat;
